"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectListbox = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const roving_focus_controller_1 = require("@/controllers/roving-focus-controller");
/**
 * mm-select의 선택지 목록. menu와 달리 선택 상태를 유지하는 listbox라 menu 계열 그룹을 빌리지 않고,
 * 목록 하나를 tab stop 하나로 두는 방향키 이동을 스스로 소유한다. 선택은 각 항목이 맡는다.
 */
let SelectListbox = class SelectListbox extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.rovingFocus = new roving_focus_controller_1.RovingFocusController(this, {
            getItems: () => this.items,
            orientation: 'vertical',
            getActiveIndex: () => this.items.findIndex(item => item.getAttribute('aria-selected') === 'true'),
        });
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'listbox');
    }
    render() {
        return (0, lit_1.html) `
      <slot @slotchange=${this.handleSlotChange}></slot>
    `;
    }
    // 목록 표면이 열릴 때 선택된 항목(없으면 첫 항목)으로 포커스를 옮긴다.
    focus() {
        this.rovingFocus.focusTabStop();
    }
    get items() {
        return this.options
            .map(option => option.shadowRoot?.querySelector('[role="option"]'))
            .filter((item) => !!item);
    }
    // 항목은 자기 shadow를 렌더한 뒤에야 포커스 대상이 생기므로, 렌더가 끝난 뒤 tab stop을 다시 맞춘다.
    async handleSlotChange() {
        await Promise.all(this.options.map(option => option.updateComplete));
        this.requestUpdate();
    }
};
SelectListbox.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
    }
  `;
__decorate([
    (0, decorators_js_1.queryAssignedElements)({ selector: 'mm-select-option' })
], SelectListbox.prototype, "options", void 0);
SelectListbox = __decorate([
    (0, decorators_js_1.customElement)('mm-select-listbox')
], SelectListbox);
exports.SelectListbox = SelectListbox;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VsZWN0LWxpc3Rib3guanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzZWxlY3QtbGlzdGJveC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQXdFO0FBSXhFLG1GQUE2RTtBQUU3RTs7O0dBR0c7QUFFSSxJQUFNLGFBQWEsR0FBbkIsTUFBTSxhQUFjLFNBQVEsZ0JBQVU7SUFBdEM7O1FBUUcsZ0JBQVcsR0FBRyxJQUFJLCtDQUFxQixDQUFDLElBQUksRUFBRTtZQUNwRCxRQUFRLEVBQUUsR0FBRyxFQUFFLENBQUMsSUFBSSxDQUFDLEtBQUs7WUFDMUIsV0FBVyxFQUFFLFVBQVU7WUFDdkIsY0FBYyxFQUFFLEdBQUcsRUFBRSxDQUNuQixJQUFJLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxZQUFZLENBQUMsZUFBZSxDQUFDLEtBQUssTUFBTSxDQUFDO1NBQzlFLENBQUMsQ0FBQTtJQTZCSixDQUFDO0lBM0JDLGlCQUFpQjtRQUNmLEtBQUssQ0FBQyxpQkFBaUIsRUFBRSxDQUFBO1FBQ3pCLElBQUksQ0FBQyxZQUFZLENBQUMsTUFBTSxFQUFFLFNBQVMsQ0FBQyxDQUFBO0lBQ3RDLENBQUM7SUFFRCxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTswQkFDVyxJQUFJLENBQUMsZ0JBQWdCO0tBQzFDLENBQUE7SUFDSCxDQUFDO0lBRUQsMkNBQTJDO0lBQzNDLEtBQUs7UUFDSCxJQUFJLENBQUMsV0FBVyxDQUFDLFlBQVksRUFBRSxDQUFBO0lBQ2pDLENBQUM7SUFFRCxJQUFZLEtBQUs7UUFDZixPQUFPLElBQUksQ0FBQyxPQUFPO2FBQ2hCLEdBQUcsQ0FBQyxNQUFNLENBQUMsRUFBRSxDQUFDLE1BQU0sQ0FBQyxVQUFVLEVBQUUsYUFBYSxDQUFjLGlCQUFpQixDQUFDLENBQUM7YUFDL0UsTUFBTSxDQUFDLENBQUMsSUFBSSxFQUF1QixFQUFFLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFBO0lBQ2xELENBQUM7SUFFRCxrRUFBa0U7SUFDMUQsS0FBSyxDQUFDLGdCQUFnQjtRQUM1QixNQUFNLE9BQU8sQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsTUFBTSxDQUFDLEVBQUUsQ0FBQyxNQUFNLENBQUMsY0FBYyxDQUFDLENBQUMsQ0FBQTtRQUNwRSxJQUFJLENBQUMsYUFBYSxFQUFFLENBQUE7SUFDdEIsQ0FBQzs7QUF4Q00sb0JBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7R0FLbEIsQ0FBQTtBQUN3RDtJQUF4RCxJQUFBLHFDQUFxQixFQUFDLEVBQUUsUUFBUSxFQUFFLGtCQUFrQixFQUFFLENBQUM7OENBQWlDO0FBUDlFLGFBQWE7SUFEekIsSUFBQSw2QkFBYSxFQUFDLG1CQUFtQixDQUFDO0dBQ3RCLGFBQWEsQ0EwQ3pCO0FBMUNZLHNDQUFhIn0=